import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgKeyboardArrowDown = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-348.44 -348.44 2488.89 2488.89",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		transform: "matrix(1 0 0 -1 0 1536)",
		d: "M1683 728 941 -13Q922 -32 896.0 -32.0Q870 -32 851 -13L109 728Q90 747 90.0 773.5Q90 800 109 819L275 984Q294 1003 320.0 1003.0Q346 1003 365 984L896 453L1427 984Q1446 1003 1472.0 1003.0Q1498 1003 1517 984L1683 819Q1702 800 1702.0 773.5Q1702 747 1683 728Z"
	})
});
export default SvgKeyboardArrowDown;
